export default __webpack_public_path__ + "static/media/loader2.c6ca326b.gif";